import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

import { Keys } from '@holmescorp/common';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { publish } from '@holmescorp/pub-sub';

import css from '../css/resource-parser.m.css';
import { includes } from 'lodash-es';

export interface RcsButtonProperties {
	path: string;
	flags?: string[];
}

const factory = create({ theme }).properties<RcsButtonProperties>();
export const RcsButton = factory(({ children, properties, middleware: { theme } }) => {
	const { key, path, flags = [] } = properties();
	const act = `site/rcs${path}`;
	const themeCss = theme.classes(css);
	const role = includes(flags, 'ariaRoleListitem') ? 'listitem button' : 'button';
	return v(
		'div',
		{
			key,
			classes: [themeCss.rcslink],
			tabIndex: 0,
			role,
			onclick: (event) => {
				event.stopPropagation();
				publish(act);
			},
			onkeydown: (event: KeyboardEvent) => {
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						publish(act);
						break;
				}
			}
		},
		children()
	);
});
